export default __webpack_public_path__ + "static/media/logo.bf23955a.svg";